import React, { useEffect, useState, useContext } from "react";
import { BuildingContext } from "Context/BuildingProvider";
import { GET_ROLE_CHECKLISTS } from "lib/roles";
import { GetRoleChecklistsQueryResult } from "generated/graphql";
import { useQuery } from "@apollo/client";
import ConfigForm, {
  ConfigInput,
  FormOption,
} from "components/Layout/ConfigForm";
import { RoleTypeEnum } from "./BasicRoleConfig";
import { LinearProgress } from "@material-ui/core";

interface BasicRoleConfigProps {
  handleTaskStartClick: (id: string | number) => void;
  handleTaskSendClick: (id: string | number) => void;
  handlePOIClick: (id: string | number) => void;
  roleType: RoleTypeEnum;
  selectedRoleTaskStarts: number[];
  selectedRoleTaskSends: number[];
  selectedPOIs: number[];
}

export default function RoleChecklists(props: BasicRoleConfigProps) {
  const { currentBuilding, updateBuilding } = useContext(BuildingContext);
  const { loading, error, data }: GetRoleChecklistsQueryResult = useQuery(
    GET_ROLE_CHECKLISTS,
    {
      variables: {
        buildingId: currentBuilding?.Id,
      },
    }
  );
  if (loading) {
    return <LinearProgress />;
  } else if (error) {
    return <div>{error.message}</div>;
  } else {
    const taskOptions: FormOption[] = data?.Task
      ? data?.Task.map((task) => {
          return {
            label: task!.Name as string,
            value: task!.Id,
          };
        })
      : [];
    const inputs: ConfigInput[] = [
      {
        title: "Tasks The User Can Start Themselves",
        type: "checklist",
        onChange: () => {},
        onOptionClick: props.handleTaskStartClick,
        selectedOptions: props.selectedRoleTaskStarts,
        xs: 12,
        sm: 6,
        id: "roleTaskStarts",
        options: taskOptions,
      },
      {
        title: "Tasks The User Can Send",
        type: "checklist",
        onChange: () => {},
        onOptionClick: props.handleTaskSendClick,
        selectedOptions: props.selectedRoleTaskSends,
        xs: 12,
        sm: 6,
        id: "roleTaskSends",
        options: taskOptions,
      },
    ];
    if (props.roleType === RoleTypeEnum.PATROL) {
      const poiOptions: FormOption[] = data?.POI
        ? data?.POI.map((poi) => {
            return {
              label: poi!.Description as string,
              value: poi!.Id,
            };
          })
        : [];
      inputs.push({
        title: "Patrol Points",
        type: "checklist",
        onChange: () => {},
        onOptionClick: props.handlePOIClick,
        selectedOptions: props.selectedPOIs,
        xs: 12,
        sm: 12,
        id: "rolePois",
        options: poiOptions,
      });
    }

    return <ConfigForm inputs={inputs}></ConfigForm>;
  }
}
